module.exports = Promise.all([parcelRequire.load("iCdWd"), parcelRequire.load("dVqC0"), parcelRequire.load("lsQMh")]).then(() => parcelRequire('40ums'));